import index from "../index/en.js"
import login from "../login/zh.js"
import projectList from "../projectList/zh.js"
import post from "../post/zh.js"
import admin from "../admin/zh.js"

export default {
  index,
  login,
  projectList,
  post,
  admin
}



// WEBPACK FOOTER //
// ./src/locale/lang/zh.js